import Api from '@/services/Index';

const getInternshipStudent = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/application/student-form',);
}
const internshipApplication = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return Api.post('/internship/application/make-application',formData,config);
}
const getAll = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications', config);
}
const show = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications/' + id);
}
const get = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications/' + id);
}
const downloadAsExcel = (config)=>{
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/internship/applications/excel-export',{...config,responseType:'arraybuffer'})
}
const update = async (id, formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/approval/step/update/status/' + id, formData);
}

const getInternshipApplications = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('internship/application/me');
}
const uploadInternshipApplicationFile = async (formData)  => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    }
    return Api.post('/internship/application/upload-document',formData,config);
}

const sendApprovedDocument = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/internship/application/update-student-document-status',formData);
}

const showDocuments = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/internship/application/show-document',formData,{responseType: 'arraybuffer'});
}

const goApprove = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/internship/application/send-approve',formData);
}




export default {
    getInternshipStudent,
    internshipApplication,
    getAll,
    show,
    get,
    update,
    downloadAsExcel,
    getInternshipApplications,
    uploadInternshipApplicationFile,
    sendApprovedDocument,
    showDocuments,
    goApprove
}
